var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"error"},[_c('h1',[_vm._v("404")]),_c('div',{staticClass:"error-message"},[_vm._v(" Извините! Страница, которую Вы ищете, не найдена. ")]),_c('div',{staticClass:"error-link",on:{"click":_vm.goBack}},[_vm._v(" На главную ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }